export default __webpack_public_path__ + "static/media/git-github.291840e5.png";